import { IBoardsResponse } from './types';
import { getApi } from '../apiClient';

export async function getBoards(params: {
  searchValue?: string;
  page?: IBoardsResponse['currentPage'];
  authorId?: number;
  teamGroupId?: number;
}): Promise<IBoardsResponse> {
  const { page, searchValue, authorId, teamGroupId } = params;
  const { data } = await getApi().get<IBoardsResponse>('/boards', {
    params: {
      page,
      ...(searchValue && { 'q[title_cont]': searchValue }),
      ...(authorId && { 'q[author_id_eq]': authorId }),
      ...(teamGroupId && { 'q[team_group_id_eq]': teamGroupId })
    }
  });

  return data;
}
